import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BzgModalService, BzgToastService, BzgToastType } from 'bz-genome-angular';
import { I18nService } from 'i18n/i18n.service';
import { TimezoneService } from './services/timezone.service';
import { ITimeZoneList } from './interfaces/ITimeZoneList';
import { ResetConfirmationComponent } from 'app/shared/components/reset-confirmation/reset-confirmation.component';
import { Router } from '@angular/router';
import { ShowToastService } from 'app/shared/services/showToast.service';

@Component({
  selector: 'biz-timezone',
  templateUrl: './timezone.component.html',
  styleUrls: ['./timezone.component.scss']
})
export class TimezoneComponent implements OnInit {
  public listTimezone: ITimeZoneList[];
  public currentTimeZone: ITimeZoneList;
  public showLoading: boolean = true;

  constructor(
    public timeZoneService: TimezoneService,
    private _i18nService: I18nService,
    private _modalService: BzgModalService,
    private _toastService: BzgToastService,
    private _translateService: TranslateService,
    private _router: Router,
    private _showToastService: ShowToastService) {
  }

  ngOnInit(): void {
    this.getTimeZonesList();
  }

  getTimeZonesList() {
    this.timeZoneService.getTimeZonesList().subscribe((response) => {
      if (response) {
        this.listTimezone = response;
        this.getCurrentTimeZone();
      }
      else
        this.listTimezone = [];
    });
  }

  getCurrentTimeZone() {
    this.timeZoneService.getTimeZoneConfiguration().subscribe((response) => {
      if (response)
        this.currentTimeZone = response;
      else
        this.currentTimeZone = null;
      this.showLoading = false;
    });
  }

  onSave() {
    const title = this._i18nService.instant('TIMEZONE.MODAL_TITLE_SAVE');
    const message = this._i18nService.instant('TIMEZONE.MODAL_MESSAGE_SAVE');
    const modal = this._modalService.open(ResetConfirmationComponent, {
      closeOnBackdropClick: false,
      closeOnRouterNavigation: true,
      data: { title, message, button: 'GLOBAL.SAVE' }
    });
    modal.afterClosed().subscribe((result) => {
      if (result === 'reset') {
        this.onSaveService();
      }
    });
  }

  onSaveService() {
    this.showLoading = true;
    this.currentTimeZone = this.listTimezone.find(x => x.Id === this.currentTimeZone.Id);
    this.timeZoneService.saveEnvironmentTimeZone(this.currentTimeZone).subscribe(
      () => {
        this._showToastService.showToast(this._i18nService.instant('GLOBAL.THE_OPERATION_WAS_SAVED_SUCCESSFULLY'), 'success');
        this.getCurrentTimeZone();
        setTimeout(() => {
          this.reloadCurrentView();
        }, 1000);
      },
      (error) => {
        this._showToastService.showToast(this._i18nService.instant('GLOBAL.AN_ERROR_HAS_OCCURRED'), 'error');
        this.showLoading = false;
      }
    );
  }

  reloadCurrentView() {
    sessionStorage.setItem('realoadView', 'true');
  }
}
